import logo from '../assets/logo_mhlog.png'
import { navigation } from '../content/siteContent'

export default function Header({ solid, activeSection, mobileOpen, setMobileOpen }) {
  return <>
    <header id="hdr" className={solid ? 'solid' : ''}>
      <a href="#inicio" className="logo-a"><img src={logo} alt="MH LOG Express" className="logo-img" /></a>
      <nav>{navigation.map(([href,label]) => <a key={href} href={href} className={`nl${activeSection === href.slice(1) ? ' active' : ''}`}>{label}</a>)}<a href="#contato" className="ncta">Contato</a></nav>
      <button className={`hbg${mobileOpen ? ' open' : ''}`} onClick={() => setMobileOpen(!mobileOpen)} aria-label="Menu"><span/><span/><span/></button>
    </header>
    <div className={`mnav${mobileOpen ? ' open' : ''}`} id="mnav">
      <button className="mnav-close" onClick={() => setMobileOpen(false)} aria-label="Fechar menu">✕</button><div className="mnav-line" />
      {navigation.map(([href,label]) => <a key={href} href={href} onClick={() => setMobileOpen(false)}>{label}</a>)}
      <a href="#contato" className="mnav-cta" onClick={() => setMobileOpen(false)}>Contato</a>
    </div>
  </>
}
